<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate"
  [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div *ngIf="type == 'pdf' || type == 'txt'" class="h-full">
    <iframe [src]="safeUrl" height="100%" width="100%"></iframe>
  </div>
  <div *ngIf="type == 'img'" class="h-full content-center">
    <img [src]="safeUrl" class="m-auto w-full" style="object-fit: scale-down; max-height: calc(95vh - 200px)"/>
  </div>
  <div *ngIf="type == 'other'" style="height: 100%; display: flex; justify-content: center; align-items: center;">
    <span>No viewer available for this file type</span>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button (click)="prev()" [disabled]="!hasPrev()"
      pButton type="button" class="p-button-raised">
      &lt; Prev
    </button>
    <button (click)="next()" [disabled]="!hasNext()"
      pButton type="button" class="p-button-raised">
      Next &gt;
    </button>
    <div class="grow content-center"><span class="text-bold ml-12 mr-12 self-middle">{{fileName}}</span></div>
    <a [href]="safeUrl" target="_self" [download]="fileName" 
      class="p-button p-button-raised" style="color: white">
      Download
    </a>

    <button *ngIf="params.deleteFn" (click)="deleteDoc()" 
      pButton type="button" class="p-button-raised" icon="pi pi-trash">
      Delete
    </button>
    <button (click)="close()" 
      pButton type="button" class="p-button-raised">
      Close
    </button>
  </div>

</ng-template>